import {memoize} from 'lodash';
import React, {useEffect, useState} from 'react';

const MaskedImage = props => {
    const {src, color, className = '', style} = props,
        maskedImageSource = useMaskedImage(src, color);

    if (!maskedImageSource) return null;

    return <div className={['MaskedImage', className].join(' ')} style={{...style, backgroundImage: `url(${maskedImageSource})`}}></div>;
};

export default MaskedImage;

export const useMaskedImage = (src, color) => {
    const [maskedImageSource, setMaskedImageSource] = useState();

    useEffect(() => {
        if (src) {
            let mounted = true;

            (async () => {
                let maskedImageSource = await maskImage(src, color);
                if (mounted) setMaskedImageSource(maskedImageSource);
            })();

            return () => (mounted = false);
        }
    }, [src, color]);

    return maskedImageSource;
};

export const maskImage = memoize(
    (src, color) => {
        return new Promise(resolve => {
            let image = new Image();
            image.onload = () => {
                if (color) {
                    let canvas = document.createElement('canvas'),
                        context = canvas.getContext('2d');

                    canvas.width = image.width;
                    canvas.height = image.height;

                    context.beginPath();
                    context.drawImage(image, 0, 0, image.width, image.height);

                    context.globalCompositeOperation = 'source-atop';
                    context.rect(0, 0, image.width, image.height);
                    context.fillStyle = color;
                    context.fill();

                    resolve(canvas.toDataURL());
                } else {
                    resolve(src);
                }
            };
            image.src = src;
        });
    },
    (...args) => args.join()
);
